<template>
  <div class="filters--industries">
    <div class="subcategories-sidebar">
      <h4><a data-toggle="collapse" href="#industry_filter" role="button" aria-expanded="true" aria-controls="industry_filter"  class="filter-toggle">{{ filterTitle }} </a></h4>
      <div class="collapse show" id="industry_filter">
        <template v-for="filter in availableIndustriesIds">
          <div class="sub-categories-list radio" v-if="filter.counter > 0" v-bind:key="filter.id"
            v-bind:class="{ 'active': selectedIndustryId === filter.id }">
            <!-- <input type="radio" name="industry"
                      v-bind:id="'industry-' + filter.id"
                      v-bind:value="filter.id">
                <label v-bind:for="'industry-' + filter.id">{{ filter.label }}</label>
                <span class="disable" v-if="selectedIndustryId === filter.id">x</span> -->
            <a v-bind:href="filter.alias" class="sub_category_link">
              <img v-bind:src="filter.image_url" class="sub_category_img" />
              <img v-bind:src="filter.image_hover_url" class="sub_category_img_hover" />
              <span>{{ filter.label }}</span>
            </a>
            <span class="counter" v-if="filter.counter > 0">({{ filter.counter }})</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustryFilter',
  props: {
    availableIndustriesIds: Array,
    initialSubIndustry: String,
  },
  data() {
    return {
      filterTitle: 'Sub Categories',
      selectedIndustryId: '',
    }
  },
  watch: {
    initialSubIndustry: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedIndustryId = val;
          this.$emit('clearInitialSubIndustry');
        }
      }
    }
  },
  methods: {
    onIndustrySelect: function (event, industry) {
      event.preventDefault();

      if (this.selectedIndustryId === industry.id) {
        this.selectedIndustryId = '';
        this.$emit("clearAllFilters");
      } else {
        this.selectedIndustryId = industry.id;
        const filters = industry.parents && Array.isArray(industry.parents)
          ? [...industry.parents, industry.id]
          : [industry.id];
        this.$emit("applyIndustryFilters", filters);
      }
    }
  }
}
</script>